




































import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import RegulatoryDocumentListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/StaticPageModels/RegulatoryDocumentListItem";
@Component
export default class PageRegulatoryDocumentsComponent extends Vue {
  model: WsResponseModel<RegulatoryDocumentListItem[]> = null;

  created() {
    this.getRegulatoryDocumentsList();
          this.$meta.setTitle('Нормативные документы');
  }

  getRegulatoryDocumentsList() {
    this.$api.StaticPagesService.GetRegulatoryDocumentsListEvent.once(
      this.onGetRegulatoryDocumentsList.bind(this)
    );
    this.$api.StaticPagesService.GetRegulatoryDocumentsList();
  }
  onGetRegulatoryDocumentsList(
    response: WsResponseModel<RegulatoryDocumentListItem[]>
  ) {
    this.model = response;
  }
}
